export const MAX_CUES = 64;
const collapse = (text) => text.split(/\s+/).filter(Boolean).join(' ');
/** Why these cues cannot be used, or undefined when they can. */
export function checkCues(cues, expect = {}) {
    if (!Array.isArray(cues) || cues.length === 0 || cues.length > MAX_CUES)
        return 'not 1-64 cues';
    let last = 0;
    for (const [i, cue] of cues.entries()) {
        const { start, end, text } = (cue ?? {});
        if (!Number.isFinite(start) || !Number.isFinite(end))
            return `cue ${i}: no times`;
        if (start < last - 0.001 || end <= start)
            return `cue ${i}: out of order`;
        if (typeof text !== 'string' || text === '' || collapse(text) !== text)
            return `cue ${i}: no text`;
        last = end;
    }
    if (expect.seconds !== undefined && last > expect.seconds + 0.05)
        return 'cues run past the audio';
    if (expect.text !== undefined &&
        cues.map((cue) => cue.text).join(' ') !== collapse(expect.text)) {
        return 'cues do not say the text';
    }
    return undefined;
}
//# sourceMappingURL=cues.js.map